var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgPhone(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 8H9.778A1.78 1.78 0 008 9.778C8 17.633 14.367 24 22.222 24A1.78 1.78 0 0024 22.222v-2.714a1.78 1.78 0 00-1.778-1.778 7.904 7.904 0 01-2.125-.29l-.483-.146a1.774 1.774 0 00-1.669.472l-1.178 1.178-.03-.017a10.802 10.802 0 01-3.468-3.35l-.215-.344 1.18-1.178a1.78 1.78 0 00.441-1.8 7.861 7.861 0 01-.397-2.477A1.78 1.78 0 0012.5 8zm0 1a.78.78 0 01.778.778c0 .972.155 1.905.443 2.776a.78.78 0 01-.194.794l-1.711 1.71a11.781 11.781 0 005.125 5.126l1.711-1.71c.21-.21.521-.28.794-.187a8.874 8.874 0 002.776.443.78.78 0 01.778.778v2.714a.78.78 0 01-.778.778C14.92 23 9 17.081 9 9.778A.78.78 0 019.778 9H12.5z"
  }));
}

export default SvgPhone;